module.exports = __webpack_public_path__ + "43845b88a417f02ee171b9c987b1b473.pdf";